<template>
    <div class="question-container" v-loading="loading" element-loading-text="提交中"
        element-loading-spinner="el-icon-loading">
        <!--<p>question + {{questionID}}</p>-->
        <!-- 题目目录 -->
        <el-dialog title="声明" :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false" @close='closeDialog()'>
            <span>基于个体心理情绪特征的复杂性，以及自我心理测评可能的局限性，本测评结果只可作为个体近期心理健康水平的参考，不可作为心理问题的临床诊断结论，如有进一步需求或疑问，请及时联系专业机构人员。
                同意参加系统测评，意味着本人知情同意。</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="centerDialogVisible = false" :disabled="buttonDisabled">{{ buttonText
                    }}</el-button>
            </span>
        </el-dialog>
        <video id="circle" ref="circle" playsinline webkit-playsinline :height="100" :width="100"
            :style="{ left: circleX + 'px', top: circleY + 'px' }" @mousedown="onMouseDown"
            @touchstart="onTouchStart"></video>
        <div class="face-capture" style="position: relative;z-index: -1;opacity: 0;">
            <video :height="vheight" :width="vwidth" id="video" playsinline webkit-playsinline></video>
            <canvas :height="cheight" :width="cwidth" id="refCanvas"></canvas>
        </div>
        <div style="position: relative;z-index: 99;">
            <div class="tag-group" ref="tags">
                <el-tag type="primary" effect="plain" v-for="index in subjects.length" style="cursor: pointer"
                    @click="goToQues(index)" v-show="false">
                    {{ index }}
                </el-tag>
            </div>
            <div :style="{ 'text-align': 'center', 'margin-bottom': '1rem', 'color': islian ? '#2ed573' : '#ff4757' }">
                {{ scanTip }}</div>
            <!--答题内容区域-->
            <el-card class="box-card" v-for="(subject, questionIndex) in subjects" :key="subject.id"
                v-show="questionIndex === questionID">
                <!-- <div slot="header" class="clearfix top">
                <span>指导语：请根据你的日常习惯选择。 </span>
            </div> -->
                <!-- 题目内容 -->

                <div slot="header" class="clearfix">
                    <div v-show="questionIndex < 10" class="ques-head" style="margin-bottom: 10px;">
                        对于每个句子，请以星星的数量来展示句子描述你的准确程度。
                        诚实回答哦！这不是考试，答案没有对错！
                        如果你觉得句子描述你一点也不准确，就打一颗星~
                        如果你觉得句子描述你很准确，就打五颗星~

                    </div>
                    <span class="ques-head">{{ subject.question }}</span>
                </div>
                <!-- 题目选项 -->
                <div v-if="subject.answer && subject.answer.length > 0">
                    <div v-for="(answer, choiceIndex) in subject.answer" :key="choiceIndex" class="input-text"
                        @click="getChoice(questionIndex, choiceIndex, answer[1])">
                        <input type="radio" :name="questionIndex" :checked="checkedID === choiceIndex" :value=answer[1]>
                        <span>{{ answer[0] }}</span>
                    </div>
                </div>
                <div v-else>
                    <input class="usermsg" type="text" placeholder="请输入答案" value="" :name="questionIndex"
                        @input="getInput(questionIndex, $event)" autocomplete="off">
                </div>

            </el-card>
            <!-- 答题进度条 -->
            <div class="progress-area">
                <el-progress :text-inside="true" :stroke-width="14" :percentage="progressPercent"
                    :status="progressStyle"></el-progress>
            </div>


            <!-- 功能按钮 -->
            <div class="buttons-group">
                <!-- <el-button type="primary" @click="prevSubject">上一题</el-button> -->
                <el-button type="primary" @click="nextSubject">下一题</el-button>
                <el-button type="primary" @click="submitAll" :disabled="isSubmitted">提交</el-button>
                <!--            <el-button type="primary" @click="debug">Skip</el-button>-->
            </div>
        </div>



    </div>
</template>

<script>
import api from '@/api/index'
require('tracking/build/tracking-min.js');
require('tracking/build/data/face-min.js');
require('tracking/build/data/eye-min.js');
require('tracking/build/data/mouth-min.js');
export default {
    name: "Question",
    data() {
        return {
            questions: [],
            questionID: 0,  //问题的索引值，默认显示第一题
            checkedID: -1,  //选项的索引值，未选择时为-1
            progressPercent: 0, //
            progressStyle: 'warning',
            subjects: [

            ],
            sj_id: 0,
            screenSize: {
                width: window.screen.width,
                height: window.screen.height,
            },
            URL: null,
            streamIns: null, // 视频流
            showContainer: true, // 显示
            tracker: null,
            tipFlag: false, // 提示用户已经检测到
            flag: false, // 判断是否已经拍照
            context: null, // canvas上下文
            profile: [], // 轮廓
            removePhotoID: null, // 停止转换图片
            scanTip: "等待确认权限...", // 提示文字
            imgUrl: "",
            canvas: null,
            trackertask: null,
            vwidth: "266",
            vheight: "266",
            cwidth: "266",
            cheight: "266",
            userInfo: {},
            orderData: {},
            Nums: 6,
            upCounter: 0,
            islian: false,
            loading: false,
            title: '',
            times: [],
            elapsedTime: 0, // 用于存储答题所用时间的变量
            timerID: null, // 计时器的ID
            isAnswered: false, // 用于判断是否已经答题
            centerDialogVisible: false,
            buttonText: '',
            buttonDisabled: true,
            circleX: 0,
            circleY: window.innerHeight - 150,
            initialX: 0,
            initialY: 0,
            dragging: false,
            isSubmitted: false,

        }
    },
    created() {
        // this.$http({
        //     method: 'get',
        //     url: api.Question,
        // }).then((res) => {
        //     // console.log(res.data);
        //     this.questions = res.data;
        //     this.setData();
        // }).catch((error) => {
        //     console.log(error);
        // });

        var that = this;
        var sj_id = that.$route.params.sj_id;
        that.sj_id = sj_id;
        var user_id = that.$store.state.uid;
        if (user_id === 0) {
            that.$router.push('/sj/' + sj_id);
            return;
        }
        that.$http({
            method: 'post',
            url: 'https://xl.880802.club/index/getQuestion_61',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: {
                sj_id: that.sj_id,
                uid: that.$store.state.uid
            }
        }).then((res) => {
            // console.log(res.data);
            if (res.data.code === 0) {
                that.questions = res.data.tiku;
                that.title = '小学生心理健康多模态情绪综合测评量表(MQ61)';
                that.setData();
                that.fetchData();
                that.startTimer();
            } else {
                // alert(res.data.msg);
                that.$router.push(res.data.path);
            }

        }).catch((error) => {
            console.log(error);
        });
        that.$store.commit('deleteRecord');
        that.openDialog();
    },
    beforeDestroy() {
        // 在组件销毁前关闭摄像头和停止人脸追踪
        this.close();
    },
    methods: {
        debug() {
            this.$router.push('/video')
        },
        setData() {
            this.subjects = [];
            // console.log(this.questions);

            this.questions.forEach(tiku => {
                // this.subjects.push({
                //     id: item[0],
                //     question: item[1],
                //     answer: [item[2], item[3], item[4], item[5]],
                //     // rightAnswer: item[6]
                // })
                const answer = [];
                tiku['xuanxianglist'].forEach(item => {
                    answer.push([item['xuanxiang'], item['fenzhi']]);
                });
                // console.log(answer);

                tiku['timu'].forEach(item => {
                    // console.log(fenzhi);
                    this.subjects.push({
                        id: item['index'],
                        question: item['timu'],
                        answer: answer,
                        // rightAnswer: item[6]
                    })
                });
            })
            // console.log(this.subjects);
        },
        //点击下一题触发
        nextSubject() {
            if (this.isAnswered == false) {
                // 用户尚未答题，给出提示
                this.$message({
                    message: '请先完成本题再进入下一题',
                    center: true,
                    type: 'warning',
                    showClose: true,
                    duration: 2000
                });
                return;
            }
            if (this.islian) {
                this.takePhoto(this.questionID);
            } else {
                this.$message({
                    message: '请保持面部在摄像头中',
                    center: true,
                    type: 'warning',
                    showClose: true,
                    duration: 2000
                })
                return;
            }
            //判断是否是最后一题
            if (this.questionID === this.subjects.length - 1) {
                this.questionID = this.subjects.length - 1;
                this.$message({
                    message: '已经是最后一题，确认无误可以点击提交',
                    center: true,
                    type: 'warning',
                    showClose: true,
                    duration: 2000
                })
                return;
            } else {
                this.questionID += 1
            }
            this.checkedID = -1;
            this.showChoice(this.questionID)
            this.isAnswered = false;
            //计时
            this.updataUseTime();
        },
        //点击上一题触发
        prevSubject() {
            //判断是否是第一题
            if (this.questionID === 0) {
                this.questionID = 0;
                this.$message({
                    message: '已经是第一题',
                    center: true,
                    type: 'warning',
                    showClose: true,
                    duration: 1000
                })
            } else {
                this.questionID -= 1
            }
            this.checkedID = -1;
            this.showChoice(this.questionID)
        },
        //每次点击选项都触发，获取题号和选项，并放到store中保存
        getChoice(quesIndex, choiceIndex, selectedValue) {
            // var correctness = false;
            var val = selectedValue;
            console.log(val);
            var category = '0';
            this.subjects.forEach(item => {
                if (item.id === quesIndex + 1) {
                    // if (item.answer[choiceIndex] === item.rightAnswer) {
                    //     correctness = true
                    // }
                    category = item.rightAnswer
                }
            });
            var choice = {
                quesIndex: quesIndex,
                choiceIndex: choiceIndex,
                correctness: category,
                val: val
                // correctness: correctness
            };
            this.checkedID = choiceIndex;
            this.$refs.tags.children[quesIndex].className = 'el-tag el-tag--primary el-tag--dark'
            this.$store.commit('updateRecord', choice);
            this.changeProgress()
        },
        getInput(quesIndex, e) {
            var val = e.target.value;
            console.log(val);
            var choice = {
                quesIndex: quesIndex,
                choiceIndex: 0,
                correctness: 0,
                val: val
                // correctness: correctness
            };
            this.$refs.tags.children[quesIndex].className = 'el-tag el-tag--primary el-tag--dark'
            this.$store.commit('updateRecord', choice);
            this.changeProgress()
            console.log(this.$store.state.choices);
        },
        //每次显示题目的同时获取该题目已选择哪一项并显示
        showChoice(id) {
            var choices = this.$store.state.choices
            var choice = -1
            choices.forEach(item => {
                if (item.quesIndex === id) {
                    choice = item.choiceIndex
                }
            })
            this.checkedID = choice
        },
        //更新进度条长度
        changeProgress() {
            var storeLen = this.$store.state.choices.length
            var subjectsLen = this.subjects.length
            if (storeLen === 0) {
                this.progressPercent = 0
                return;
            }
            this.progressPercent = Math.floor(storeLen / subjectsLen * 100)
            if (this.progressPercent === 100) {
                this.progressStyle = 'success'
            }
            this.isAnswered = true;
        },
        goToQues(index) {
            this.questionID = index - 1
            this.showChoice(this.questionID)
        },
        formResult(data) {
            var choices = this.$store.state.choices;
            choices.forEach(item => {
                data.push({
                    // Index: item.quesIndex,
                    // choice: item.choiceIndex,
                    faceKey: item.faceKey,
                    faceVal: item.faceVal,
                    val: item.val
                })
            })
        },
        //提交并评分
        submitAll() {
            this.isSubmitted = true;
            //判断是否还有未选择的题目
            var storeLen = this.$store.state.choices.length
            var subjectsLen = this.subjects.length
            var timesLen = this.times.length
            if (storeLen < subjectsLen) {
                this.$message({
                    message: '提交失败，请完成所有题目再提交',
                    center: true,
                    type: 'error',
                    showClose: true,
                    duration: 2000
                })
                this.isSubmitted = false;
                return;
            } else {
                if (timesLen < subjectsLen) {
                    this.updataUseTime(false);
                }
                // this.$store.commit('getScore');
                var that = this;
                var answers = [];
                var scores = '';
                var g = new Date().getTime();
                if (that.islian) {
                    console.log(that.subjects.length - 1);
                    that.takePhoto(that.subjects.length - 1);
                } else {
                    that.$message({
                        message: '请保持面部在摄像头中',
                        center: true,
                        type: 'warning',
                        showClose: true,
                        duration: 2000
                    })
                    this.isSubmitted = false;
                    return;
                }
                that.formResult(answers);
                console.log(answers);
                that.$store.commit('calScores');
                scores = '[' + that.$store.state.cat_score1 + ',' +
                    that.$store.state.cat_score2 + ',' + that.$store.state.cat_score3 + ']';



                that.$http({
                    method: 'post',
                    url: 'https://xl.880802.club/index/goAnswer_69',
                    // headers: {
                    //     'Content-Type': 'application/x-www-form-urlencoded'
                    // },
                    data: {
                        user_id: that.$store.state.uid,
                        result: answers,
                        time: g,
                        sj_id: that.sj_id,
                        times: that.times,
                    }
                }).then(function (res) {
                    // console.log(res.data);
                    if (res.data.code == 0) {
                        alert(res.data.msg)
                        this.isSubmitted = false;
                    } else {
                        that.$message({
                            message: '提交成功',
                            center: true,
                            type: 'success',
                            showClose: true,
                            duration: 1500
                        });
                        that.$router.push('/testScore/' + that.sj_id)
                        this.isSubmitted = false;
                        // console.log(this.$store.state);
                        // this.$store.commit('getScore');
                        // const u = navigator.userAgent;
                        // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                        // if (isiOS) {
                        //     that.$router.push('/score')
                        // } else {
                        //     that.$router.push('/video')
                        // }
                    }
                })
                // this.$message({
                //               message: '提交成功',
                //               center: true,
                //               type: 'success',
                //               showClose: true,
                //               duration: 1500
                //           });
                //           // console.log(this.$store.state);
                //           this.$store.commit('getScore');
                //           this.$router.push('/video')
            }
        },


        playVideo() {
            this.getUserMedia(
                { //摄像头拍摄的区域
                    video: {
                        width: 500,
                        height: 500,
                        facingMode: "user",
                    } /* 前置优先 */,
                },
                this.success,
                this.error
            );
        },
        // 访问用户媒体设备
        getUserMedia(constrains, success, error) {
            if (navigator.mediaDevices.getUserMedia) {
                //最新标准API
                navigator.mediaDevices
                    .getUserMedia(constrains)
                    .then(success)
                    .catch(error);
            } else if (navigator.webkitGetUserMedia) {
                //webkit内核浏览器
                navigator.webkitGetUserMedia(constrains).then(success).catch(error);
            } else if (navigator.mozGetUserMedia) {
                //Firefox浏览器
                navagator.mozGetUserMedia(constrains).then(success).catch(error);
            } else if (navigator.getUserMedia) {
                //旧版API
                navigator.getUserMedia(constrains).then(success).catch(error);
            } else {
                this.scanTip = "您的浏览器不支持访问用户媒体设备";
            }
        },
        success(stream) {
            this.streamIns = stream;
            const video = document.getElementById("video");
            const circle = document.getElementById("circle");
            // webkit内核浏览器
            this.URL = window.URL || window.webkitURL;
            if ("srcObject" in video) {
                video.srcObject = stream;
            } else {
                video.src = this.URL.createObjectURL(stream);
            }
            if ("srcObject" in circle) {
                circle.srcObject = stream;
            } else {
                circle.src = this.URL.createObjectURL(stream);
            }
            // 苹果手机的系统弹框会阻止js的线程的继续执行 手动0.1秒之后自动执行代码
            setTimeout(() => {
                video.play();
                circle.play();
                this.initTracker();// 人脸捕捉
            }, 100);
        },
        error(e) {
            this.scanTip = "访问用户媒体被拒绝，请重试或更换浏览器";
        },
        initTracker() {
            this.context = document.getElementById("refCanvas").getContext("2d"); // 画布
            this.canvas = document.getElementById("refCanvas");
            this.tracker = new window.tracking.ObjectTracker("face"); // tracker实例
            this.tracker.setInitialScale(4);
            this.tracker.setStepSize(2); // 设置步长
            this.tracker.setEdgesDensity(0.1);
            try {
                this.trackertask = window.tracking.track("#video", this.tracker); // 开始追踪
            } catch (e) {
                this.scanTip = "访问用户媒体失败，请重试";
            }
            //开始捕捉方法 一直不停的检测人脸直到检测到人脸
            this.tracker.on("track", (e) => {
                //画布描绘之前清空画布
                this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
                if (e.data.length === 0) {
                    this.scanTip = "面部表现抓取失败";
                    this.islian = false;
                } else {
                    this.scanTip = "面部表现抓取成功";
                    this.islian = true;
                    e.data.forEach((rect) => {
                        //设置canvas 方框的颜色大小
                        this.context.strokeStyle = "#42e365";
                        this.context.lineWidth = 2;
                        this.context.strokeRect(rect.x, rect.y, rect.width, rect.height);
                    });
                }
            });
        },
        sleep(ms) {
            var unixtime_ms = new Date().getTime();
            while (new Date().getTime() < unixtime_ms + ms) { }
        },
        takePhoto(i) {
            // 在画布上面绘制拍到的照片
            this.context.drawImage(
                document.getElementById("video"), 0, 0,
                this.vwidth, this.vwidth
            );
            // 保存为base64格式
            this.imgUrl = this.saveAsPNG(document.getElementById("refCanvas"));
            // this.compare(imgUrl)
            // //判断图片大小
            this.imgSize();
            this.uploadFace(i);
            // this.close();
        },
        uploadFace(i) {  // 图像上传
            var that = this;
            let data = new FormData();
            data.append('uid', this.$store.state.uid);
            data.append('num', i);
            let blob = this.getBlobBydataURI(this.imgUrl, 'image/png');
            data.append("file", blob);
            this.$http.post('https://xl.880802.club/index/uploadFace', data).then(function (res) {
                //打印res.data.info.data类型

                console.log(res.data.info.key);
                if (res.data.msg === 'success') {
                    console.log('上传成功');
                    var choices = that.$store.state.choices
                    choices[i].faceKey = res.data.info.key;
                    choices[i].faceVal = res.data.info.val;
                    // that.$store.commit('updateRecord', choices);
                    console.log(that.$store.state.choices);
                } else {
                    console.log('上传失败');
                }
            })
        },
        imgSize() {
            if (this.imgUrl) {
                // 获取base64图片byte大小
                const equalIndex = this.imgUrl.indexOf("="); // 获取=号下标
                let size;
                if (equalIndex > 0) {
                    const str = this.imgUrl.substring(0, equalIndex); // 去除=号
                    const strLength = str.length;
                    const fileLength = strLength - (strLength / 8) * 2; // 真实的图片byte大小
                    size = Math.floor(fileLength / 1024); // 向下取整
                    // console.log("size", size + "KB");
                } else {
                    const strLength = this.imgUrl.length;
                    const fileLength = strLength - (strLength / 8) * 2;
                    size = Math.floor(fileLength / 1024); // 向下取整
                    // console.log("size", size + "KB");
                }
                if (size > 1024) {
                    // 图片超过1M 按比例压缩
                    this.imgUrl = document
                        .getElementById("refCanvas")
                        .toDataURL("image/png", 1024 / size);
                }
            }
        },
        // Base64转文件
        getBlobBydataURI(dataURI, type) {
            var binary = window.atob(dataURI.split(",")[1]);
            var array = [];
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {
                type: type,
            });
        },
        // compare(url) {
        //     let blob = this.getBlobBydataURI(url, 'image/png')
        //     let formData = new FormData()
        //     formData.append("file", blob, "file_" + Date.parse(new Date()) + ".png")
        //     // 得到文件后进行人脸识别
        // },
        // 保存为png,base64格式图片
        saveAsPNG(c) {
            return c.toDataURL("image/png", 0.4);
        },
        close() {
            this.flag = false;
            this.tipFlag = false;
            this.showContainer = false;
            this.context = null;
            this.scanTip = "人脸检测中...";
            clearTimeout(this.removePhotoID);
            if (this.streamIns) {
                this.streamIns.enabled = false;
                this.streamIns.getTracks()[0].stop();
                this.streamIns.getVideoTracks()[0].stop();
            }
            this.streamIns = null;
            this.trackertask.stop();
            this.tracker = null;
        },
        fetchData() {
            const data = this.title;
            this.$emit('update-title', data);
        },
        startTimer() {
            this.timerID = setInterval(() => {
                this.elapsedTime++; // 每秒递增1
            }, 1000); // 每秒执行一次
        },
        stopTimer() {
            clearInterval(this.timerID); // 停止计时器
        },
        updataUseTime(flg = true) {
            //停止计时
            this.stopTimer();
            //写入times数组
            if (this.elapsedTime == 0) {
                this.elapsedTime = 1;
            }
            if (this.times.length < this.subjects.length) {
                this.times.push(this.elapsedTime);
            }
            console.log(this.times);
            //elapsedTime清零
            this.elapsedTime = 0;
            //开始计时
            if (flg) {
                this.startTimer();
            }
        },
        openDialog() {
            var that = this;
            that.centerDialogVisible = true;
            //倒计时5秒后可以点击确定
            var count = 5;
            that.buttonText = '同 意(' + count + ')';
            var timer = setInterval(function () {
                count--;
                that.buttonText = '同 意(' + count + ')';
                if (count === 0) {
                    clearInterval(timer);
                    that.buttonText = '同 意';
                    that.buttonDisabled = false;
                }
            }, 1000);
        },
        closeDialog() {
            console.log('close');
            this.playVideo();
        },

        onMouseDown(e) {
            e.preventDefault();
            this.dragging = true;
            this.initialX = e.clientX - this.$refs.circle.getBoundingClientRect().left;
            this.initialY = e.clientY - this.$refs.circle.getBoundingClientRect().top;
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);
        },
        onTouchStart(e) {
            e.preventDefault();
            this.dragging = true;
            this.initialX = e.touches[0].clientX - this.$refs.circle.getBoundingClientRect().left;
            this.initialY = e.touches[0].clientY - this.$refs.circle.getBoundingClientRect().top;
            document.addEventListener('touchmove', this.onTouchMove);
            document.addEventListener('touchend', this.onTouchEnd);
        },
        onMouseMove(e) {
            if (this.dragging) {
                var x = e.clientX - this.initialX;
                var y = e.clientY - this.initialY;
                this.moveCircle(x, y);
            }
        },
        onTouchMove(e) {
            if (this.dragging) {
                var x = e.touches[0].clientX - this.initialX;
                var y = e.touches[0].clientY - this.initialY;
                this.moveCircle(x, y);
            }
        },
        onMouseUp() {
            this.dragging = false;
            document.removeEventListener('mousemove', this.onMouseMove);
            document.removeEventListener('mouseup', this.onMouseUp);
        },
        onTouchEnd() {
            this.dragging = false;
            document.removeEventListener('touchmove', this.onTouchMove);
            document.removeEventListener('touchend', this.onTouchEnd);
        },
        moveCircle(x, y) {
            x = Math.max(x, 0);
            y = Math.max(y, 0);
            x = Math.min(x, window.innerWidth - this.$refs.circle.offsetWidth);
            y = Math.min(y, window.innerHeight - this.$refs.circle.offsetHeight);
            this.circleX = x;
            this.circleY = y;
        }
    },
    mounted() {
        //设置video canvas宽高
        const scale = this.screenSize.width / 375;
        this.vwidth = 266 * scale;
        this.vheight = 266 * scale;
        this.cwidth = 266 * scale;
        this.cheight = 266 * scale;
        // this.playVideo();
        this.$store.state.scorePerQues = Math.floor(100 / this.subjects.length);  //计算分数
        this.showChoice(this.questionID);
        var choices = this.$store.state.choices;
        choices.forEach(item => {
            this.$refs.tags.children[item.quesIndex].className = 'el-tag el-tag--primary el-tag--dark'
        });
        this.changeProgress()
    },
    filters: {
        //将选项的索引值转化为ABCD...的选项
        numToChoice(num) {
            return String.fromCharCode(num + 65)
        }
    }
}
</script>

<style scoped>
.tag-group {
    margin: 1rem 0;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
}

.el-tag {
    width: 3rem;
    margin: 0 .8rem .8rem 0;
}

.el-card {
    min-height: 30rem;
}

.ques-head {
    font-size: 1.6rem;
}

.input-text {
    /* height: 3rem; */
    line-height: 3rem;
    font-size: 1.4rem;
    margin: 1rem 0;
}


.input-text input {
    margin-right: 1rem;
}

/*自定义单选框样式*/
input[type="radio"] {
    opacity: 0;
}

input[type="radio"]+span {
    position: relative;
}

input[type="radio"]+span::before {
    content: '';
    position: absolute;
    left: -2.4rem;
    top: .1rem;
    border-radius: 50%;
    width: 1.6rem;
    height: 1.6rem;
    border: .1rem solid #999;
}

input[type="radio"]+span::after {
    content: '';
    position: absolute;
    left: -2rem;
    top: .5rem;
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
}

input[type="radio"]:checked+span::before {
    border: .1rem solid #409EFF;
}

input[type="radio"]:checked+span::after {
    background: #409EFF;
}

/*自定义单选框样式结束*/

.progress-area {
    margin: 1rem 0;
}

.buttons-group {
    text-align: right;
}

.buttons-group button {
    width: 9rem;
}

.top {
    margin-bottom: 2rem;
}

.usermsg {
    height: 3rem;
    border-radius: 0.6rem;
    width: 50%;
    color: rgba(0, 0, 0, 0.8);
    font-size: 1.5rem;
    text-align: left;
}

.face-capture {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.face-capture video,
.face-capture canvas {
    position: fixed;
    top: 11.75rem;
    object-fit: cover;
    z-index: 2;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transform: translate3d(0, 0, 0);
}

#circle {
    width: 100px;
    height: 100px;
    position: fixed;
    cursor: move;
    overflow: hidden;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    /* background-color: rgba(0, 0, 0, 0.5); */
}
</style>